import { render, staticRenderFns } from "./NoticeComponent.vue?vue&type=template&id=6493adde&scoped=true"
import script from "./NoticeComponent.vue?vue&type=script&lang=js"
export * from "./NoticeComponent.vue?vue&type=script&lang=js"
import style0 from "./NoticeComponent.vue?vue&type=style&index=0&id=6493adde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6493adde",
  null
  
)

export default component.exports